export default __webpack_public_path__ + "static/thumbnail-dd69aaa725ad16e9e3029b6c80edb115.jpg";